import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LocaleService } from './core/services/locale.service';
import { NgxSpinnerComponent } from 'ngx-spinner';
import { ActivityTrackerService } from './core/activity/activity-tracker.service';
import { GlobalErrorListenerService } from './core/activity/global-error-listener.service';
import { ActingPostSwitcherComponent } from './shared/components/acting-post-switcher/acting-post-switcher.component';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet><ngx-spinner type="ball-scale-multiple"></ngx-spinner><app-acting-post-switcher></app-acting-post-switcher>',
  styles: [`:host { display: block; height: 100%; }`],
  imports: [RouterOutlet, NgxSpinnerComponent, ActingPostSwitcherComponent],
})
export class AppComponent {
  title = 'RKUMP - Mandi Parishad';
  private localeService = inject(LocaleService);

  constructor() {
    inject(ActivityTrackerService).start();
    inject(GlobalErrorListenerService).start();
  }
}
